export const SIGN_IN = '/users/sign_in'
export const SIGN_UP = '/users/sign_up'
export const FORGOT_PASSWORD = '/users/forgot_password'
export const CONFIRM_EMAIL = '/users/confirm_email/:token'
export const RESET_PASSWORD = '/users/reset_password'
export const WELCOME_PAGE = '/welcome'
export const PUBLIC_INFO = '/users/public_info'

export const ROOT = '/'
